import React from 'react';
import { FadeIn } from './FadeIn';
export function Results() {
  return <section className="py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-146">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-96 bg-amber-500/5 rounded-full blur-[100px] -z-10" data-id="element-147"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-148">
        <FadeIn data-id="element-149">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-amber-500" data-id="element-150">
            ¿Qué cambia en 7 días?
          </h2>
          <div className="space-y-6 text-xl text-lavender-100 leading-relaxed" data-id="element-151">
            <p data-id="element-152">
              Al séptimo día, el "despertar de pánico" de la madrugada
              desaparece.
            </p>
            <p className="font-medium text-white" data-id="element-153">
              Te despertarás antes de que suene la alarma, no porque no puedas
              dormir, sino porque tu cuerpo ha completado sus 4 ciclos de sueño
              profundo y está genuinamente restaurado.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}